import axios from 'axios';

const BASE_URL = '/api';

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const login = async (email, password) => {
  const form = new URLSearchParams();
  form.append('username', email);
  form.append('password', password);
  const res = await api.post('/auth/login', form, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
  return res.data;
};

export const getMe        = ()   => api.get('/auth/me').then(r => r.data);
export const getBots      = ()   => api.get('/bots/').then(r => r.data);
export const getBotStatus = (id) => api.get(`/bots/${id}/status`).then(r => r.data);
export const getBotTrades = (id) => api.get(`/bots/${id}/trades`).then(r => r.data);
export const getBotLevels = (id) => api.get(`/bots/${id}/levels`).then(r => r.data);
export const getBotConfig = (id) => api.get(`/bots/${id}/config`).then(r => r.data);
export const startBot        = (id) => api.post(`/bots/${id}/start`).then(r => r.data);
export const getBotStreamToken = (id) => api.get(`/bots/${id}/stream-token`).then(r => r.data);
export const getBotCandles     = (id, tf='5M', limit=100) => api.get(`/bots/${id}/candles?timeframe=${tf}&limit=${limit}`).then(r => r.data);
export const getBotMarkers     = (id) => api.get(`/bots/${id}/markers`).then(r => r.data);
export const restartBot   = (id) => api.post(`/bots/${id}/restart`).then(r => r.data);
export const stopBot      = (id) => api.post(`/bots/${id}/stop`).then(r => r.data);
export const getAlerts    = (includeResolved=false) => api.get(`/bots/alerts/all?include_resolved=${includeResolved}`).then(r => r.data);
export const getFleetOverview = () => api.get('/bots/fleet/overview').then(r => r.data);

export default api;
